import React from "react";

export type FidelityFormProps = {
    setIsAddFidelityClicked: React.Dispatch<React.SetStateAction<boolean>>;
    isAddFidelityClicked: boolean;
    setDataIsUpdated: React.Dispatch<React.SetStateAction<number | boolean>>;
    dataFidelity: FidelityRow | undefined;
    isAddNewFidelityButtonClicked: boolean;
    setDataFidelity: React.Dispatch<
        React.SetStateAction<FidelityRow | undefined>
    >;
    setLocalFilterActive: React.Dispatch<React.SetStateAction<boolean>>;
    fidelityChoiceIndex: number;
    setFidelityChoiceIndex: React.Dispatch<React.SetStateAction<number>>;
    isConsult: boolean;
    setIsConsult: React.Dispatch<React.SetStateAction<boolean>>;
};

export type FormValues = {
    designation: string;
    choiceFidelity: string;
    numberFidelityPoints: string;
    moneyCorrespondence: string;
    password: string;
    remark: string;
    login: string;
    user: string;
    dashboardLink: string;
    apiKey: string;
    authenticationMode: string[];
    sortedVisibility: SaleModeVisibility[];
    auresKonnectGroup: string;
};

export type FormFlags = {
    isCentralizationActive: boolean;
    isVisibiliteActive: boolean;
};

export type FormErrors = {
    designation: boolean;
    choiceFidelity: boolean;
    login: boolean;
    password: boolean;
    user: boolean;
    dashboardLink: boolean;
    apiKey: boolean;
    group: boolean;
    numberFidelityPoints: boolean;
};

export type FormStateApi = {
    values: FormValues;
    flags: FormFlags;
    errors: FormErrors;
    setValue: <K extends keyof FormValues>(key: K, v: FormValues[K]) => void;
    setFlag: <K extends keyof FormFlags>(key: K, v: FormFlags[K]) => void;
    setError: <K extends keyof FormErrors>(key: K, v: FormErrors[K]) => void;
    resetErrors: () => void;
};

export const INITIAL_VALUES: FormValues = {
    designation: "",
    choiceFidelity: "",
    numberFidelityPoints: "100",
    moneyCorrespondence: "1",
    password: "",
    remark: "",
    login: "",
    user: "",
    dashboardLink: "",
    apiKey: "",
    authenticationMode: [],
    sortedVisibility: [],
    auresKonnectGroup: "",
};

export const INITIAL_FLAGS: FormFlags = {
    isCentralizationActive: false,
    isVisibiliteActive: false,
};

export const INITIAL_ERRORS: FormErrors = {
    designation: false,
    choiceFidelity: false,
    login: false,
    password: false,
    user: false,
    dashboardLink: false,
    apiKey: false,
    group: false,
    numberFidelityPoints: false,
};

export const INPUT_ERROR_STYLE: React.CSSProperties = {
    width: "100%",
    marginTop: "0.25rem",
    fontSize: "80%",
    color: "#f46a6a",
};
